import React from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';

export function DroppableHeaderOptionsSeparator() {
  const { textColor } = useDroppableHeaderContext();

  return <span className={`${textColor} mr-5`}>·</span>;
}
